import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "popular-game" };
const _hoisted_2 = { class: "overlay md:tw-pt-20 tw-pt-6" };
const _hoisted_3 = { class: "container" };
const _hoisted_4 = { class: "row wow fadeInUp" };
const _hoisted_5 = { class: "games-carousel" };
const _hoisted_6 = { class: "single-box" };
const _hoisted_7 = ["src", "alt"];
const _hoisted_8 = { class: "tw-text-center" };
const _hoisted_9 = { class: "mt-40 d-inline-block" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Slide = _resolveComponent("Slide");
    const _component_Carousel = _resolveComponent("Carousel");
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "abs-item md:tw-block tw-hidden" }, [
                _createElementVNode("img", {
                    src: "/assets/images/popular-game-item.png",
                    alt: "icon"
                })
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row justify-content-center wow fadeInUp" }, [
                    _createElementVNode("div", { class: "col-lg-6 text-center" }, [
                        _createElementVNode("div", { class: "section-text" }, [
                            _createElementVNode("h2", { class: "tw-text-center tw-text-xl tw-font-semibold tw-text-[#ed115f]" }, " Related other games ")
                        ])
                    ])
                ], -1)),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_Carousel, _normalizeProps(_guardReactiveProps($setup.config)), {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.localGames, (game) => {
                                    return (_openBlock(), _createBlock(_component_Slide, {
                                        key: game.id,
                                        class: "single"
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_6, [
                                                _createElementVNode("img", {
                                                    src: game.image,
                                                    alt: game.title
                                                }, null, 8, _hoisted_7)
                                            ])
                                        ]),
                                        _: 2
                                    }, 1024));
                                }), 128))
                            ]),
                            _: 1
                        }, 16)
                    ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_router_link, {
                            to: "/casino/all",
                            class: "cmn-btn !tw-px-6 !tw-py-[9px] tw-mx-auto tw-font-normal"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('playNow')), 1)
                            ]),
                            _: 1
                        })
                    ])
                ])
            ])
        ])
    ]));
}
